import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      setSent(true); // never reveal whether the account exists
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <img src="/logo.png" alt="SmartHost Solutions" className="h-10 w-10 object-contain" />
          <span className="font-display text-xl font-bold">SmartHost Solutions</span>
        </div>

        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <div className="mx-auto h-12 w-12 rounded-full bg-secondary flex items-center justify-center mb-4">
              <MailCheck className="h-6 w-6 text-primary" />
            </div>
            <h2 className="font-display text-2xl font-semibold mb-2">Check your email</h2>
            <p className="text-muted-foreground text-sm">
              If an account exists for <b>{email}</b>, we've sent a link to reset your password. The
              link expires in 1 hour.
            </p>
            <Link
              to="/login"
              className="inline-flex items-center gap-1 text-sm text-primary mt-6 hover:underline"
            >
              <ArrowLeft className="h-4 w-4" /> Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <h2 className="font-display text-2xl font-semibold mb-1">Forgot your password?</h2>
            <p className="text-muted-foreground text-sm mb-8">
              Enter your email and we'll send you a reset link.
            </p>
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="you@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="forgot-email-input"
                />
              </div>
              <Button
                type="submit"
                className="w-full h-11 text-base"
                disabled={loading}
                data-testid="forgot-submit-button"
              >
                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                Send reset link
              </Button>
            </form>
            <Link
              to="/login"
              className="inline-flex items-center gap-1 text-sm text-muted-foreground mt-6 hover:text-foreground"
            >
              <ArrowLeft className="h-4 w-4" /> Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
